<template>
  <el-dialog
    :title="title"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="import-dialog"
    top="40px"
    append-to-body
    width="1100px"
    @close="onCancel">
    <div style="height: 100%;position: relative;background: #f5f5f5;">
      <template v-if="type === 2">
<!--        <div class="box title">计划管理</div>-->
        <div class="box row">
          <div>
            <div class="header-text">商品ID：{{rowList.versionCode}}</div>
            <div class="header-text">商品名称：{{rowList.productName}}</div>
          </div>
          <div @click="addPlan">添加计划</div>
        </div>
      </template>
      <div v-if="type === 1 || type === 3" class="box row">
        <div class="header-num">
          <div class="yuan">1</div>
          已选 {{rowAdd.length}} 件推广商品
        </div>
        <div  class="header-set">
          <div class="yuan">2</div>
          佣金策略设置
        </div>
      </div>
      <div class="box" v-loading="loading">
        <el-tabs v-model="activeName" @tab-click="handleChange">
          <el-tab-pane v-for="item in tabsList" :key="item.name" :label="item.label" :name="item.name"></el-tab-pane>
        </el-tabs>
        <div class="list-container">
          <div class="list-header">
            <div>
              <template v-if="activeName === '3'">
                <span style="background: #f3f4f6;padding: 4px 8px;">
                <i class="el-icon-s-custom"></i>全部达人
              </span>
              </template>
            </div>
<!--            <div @click="handleAdd" class="add" v-if="activeName !== '3' && type === 2">+添加达人</div>-->
          </div>
          <div class="list">
            <el-form v-if="type === 1 || type === 3" :model="form1" ref="formRef1">
              <div v-for="(item,index) in form1.items" :key="index" class="item">
                <div style="margin-right: 10px;">
                  <el-form-item :error="item.errorNamne" label="" label-width="">
                    <el-input
                      v-model="item.planName"
                      style="width: 200px;"
                      placeholder="编辑名字"
                      @input="handleInput($event, index,'planName')"
                    >
                    </el-input>
                  </el-form-item>
                </div>
                <div class="item-box">
                  <div class="item-box-left">商品ID：</div>
                  <div class="item-box-right">{{item.thirdProductId}}</div>
                </div>
                <div class="item-box">
                  <div class="item-box-left">商品名称：</div>
                  <div class="item-box-right">{{item.productName}}</div>
                </div>
                <div v-if="activeName !== '3'" class="item-box" style="position: relative;">
                  <div class="item-box-left">{{item.darens.length}}个达人</div>
                  <div v-if="item.errorDarens" style="position: absolute;bottom: 4px;left: 0;color:#F56C6C;font-size: 12px;">请添加达人</div>
                </div>
                <div v-if="activeName === '3'" class="item-box-el-form">
                  <el-form-item :error="item.error" label="佣金设置" label-width="100px">
                    <el-input
                      v-model="item.commissionRate"
                      style="width: 200px;"
                      placeholder="1~29"
                      @input="handleInput($event, index,'commissionRate')"
                      @blur="handleBlur($event, index)"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </div>
                <div v-if="activeName !== '3'" @click="handleAdd(item)" class="add item-box">
                  <span>+添加达人</span>
                </div>
                <div v-if="activeName === '1'" class="picker-container">
                  <el-form-item label="请选择开始和结束时间" prop="grantTimeArr" label-width="160px" :error="timeErr">
                    <el-date-picker
                      style="width: 400px;"
                      v-model="form1.grantTimeArr"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetimerange"
                      align="right"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      range-separator="至"
                      :default-time="['00:00:00', '23:59:59']"
                      :clearable="false"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="请输入计划取消后的有效时间" label-width="200px" :error="timeDayErr">
                    <el-input
                      v-model="form1.commissionDuration"
                      style="width: 140px;"
                      @input="handleInput($event, index,'commissionDuration')"
                      @blur="handleBlur($event, index)"
                    >
                      <template slot="append">天</template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              <div v-if="activeName === '1'" style="height: 50px;"></div>
            </el-form>
            <el-form v-if="type === 2" :model="form" ref="form">
              <div v-for="(item,index) in form.items" :key="index" class="item">
                <div class="item-box">
                  <div class="item-box-left">计划ID：</div>
                  <div class="item-box-right">{{item.planId}}</div>
                </div>
                <div class="item-box">
                  <div class="item-box-left">计划名称：</div>
                  <div class="item-box-right">{{item.planName}}</div>
                </div>
                <div class="item-box">
                  <div class="item-box-left">抖音ID：</div>
                  <div class="item-box-right">{{item.douyinId}}</div>
                </div>
                <div class="item-box-el-form">
                  <el-form-item :error="item.error" label="佣金设置" label-width="100px">
                    <el-input
                      v-model="item.commissionRate"
                      style="width: 200px;"
                      placeholder="1~29"
                      @input="handleInput($event, index,'commissionRate')"
                      @blur="handleBlur($event, index)"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </div>
                <div @click="handleDelete(item,index)" class="item-box add">关闭</div>
                <div v-if="activeName === '1'" class="picker-container">
                    <el-form-item label="请选择开始和结束时间" prop="grantTimeArr" label-width="160px" :error="timeErr">
                      <el-date-picker
                        style="width: 400px;"
                        v-model="form.grantTimeArr"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        align="right"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        range-separator="至"
                        :default-time="['00:00:00', '23:59:59']"
                        :clearable="false"
                        :picker-options="pickerOptions"
                      >
                      </el-date-picker>
                    </el-form-item>
                </div>
              </div>
              <div v-if="activeName === '1'" style="height: 50px;"></div>
            </el-form>
          </div>
        </div>
      </div>

      <div class="btns-coantainer">
        <el-button type="warning" plain @click="onCancel">取消</el-button>
        <el-button :loading="submitLoading" type="warning" @click="submit"
        >提交</el-button
        >
      </div>
    </div>
    <addExpertPop
      v-if="addExpertPopVisible"
      v-model="addExpertPopVisible"
      :oldDarens = "oldDarens"
      @close="addExpertPopVisible = false"
      @expertSubmit="handleExpertSubmit"
    ></addExpertPop>
<!--    <manageDetailPop ref="manageDetailPopRef"></manageDetailPop>-->
  </el-dialog>
</template>

<script>
import addExpertPop from "./addExpertPop.vue";
import {matchNegativePart3,matchIntegerNew} from "@/utils/regExp.js";
// import manageDetailPop from './manageDetailPop.vue';
import mini from "@/api/mini";
const MiniModel = new mini();
export default {
  name: "manageDetailPopNew",
  components: { addExpertPop},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      // 临时 ，默认0
      type:0,
      title:'计划管理',
      addExpertPopVisible:false,
      loading:false,
      dialogVisible: false,
      submitLoading: false,
      activeName:'3',
      tabsList:[
        {
          label: '通用计划',
          name: '3',
        },
        {
          label: '短视频定向计划',
          name: '1',
        },
        {
          label: '直播定向计划',
          name: '2',
        }
      ],
      form1Default:[],
      form1: {
        grantTimeArr:"",
        items :[
            // {
            //   "productName": "9代12元代金券",
            //   "productCover": "http://shoutudyp.oss-cn-shenzhen.aliyuncs.com/images/877deff14bf3b1ab1ddcb54f6805f2dc.jpg",
            //   "thirdProductId": "7496711498232809000",
            //   "isPromote": 1,
            //   "notPromoteReason": "",
            //   "isPromoteStr": "是",
            //   commissionRate: '',
            //   planName:'', //计划名称
            //   darens:[],//达人列表
            // },
            // {
            //   "productName": "9.91代30优惠券",
            //   "productCover": "https://shouto-openplatform.oss-cn-hangzhou.aliyuncs.com/image/8cfc788f-0f3d-48b7-90a0-1e9e0eef13a8.png",
            //   "thirdProductId": "7497061200077801000",
            //   "isPromote": 1,
            //   "notPromoteReason": "",
            //   "isPromoteStr": "是",
            //   commissionRate: '',
            //   planName:'', //计划名称
            //   darens:[],//达人列表
            // }
        ]
      },
      form: {
        grantTimeArr:"",
        commissionDuration:'',
        items :[
          // {
          //   planId: '2234',
          //   planName: '15代金券2234',
          //   thirdProductId: '221',
          //   commissionRate: '2',
          //   id:'',
          //   error:'',
          // },
        ]
      },
      formDefault:{
        1:{},
        2:{},
        3:{},
      },
      timeErr:'',
      addDarenItem:null,
      oldDarens:[],
      rowList:null,
      rowAdd:[],
      timeDayErr: '',
      disabled: false,
    }
  },
  created() {

  },
  methods:{
    addPlan() {
      this.$refs.manageDetailPopRef.open(3, this.rowList);
    },
    getTime() {
      const startTime = this.$moment().add(1, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const endTime = this.$moment(startTime, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');

      return {
        startTime,
        endTime,
      };
    },
    handleExpertSubmit(list) {
      console.log(list,'handleExpertSubmithandleExpertSubmit===添加达人')
      if(this.type === 1 || this.type === 3) {
        let index = this.form1.items.findIndex(item => {
          return item.thirdProductId === this.addDarenItem.thirdProductId
        })
        this.form1.items[index].darens = list.map(item => {
          return {
            douyinId: item.douyinId,
            commissionRate: item.commissionRate,
            disabled: item.disabled ? item.disabled :false,
          }
        });
        this.form1.items[index].errorDarens = '';
        console.log(this.form1,'this.form1')
        this.addExpertPopVisible = false
      }else if(this.type === 2) {
        this.form.items.forEach(item => {
          item.darens = list;
        });
      }
      this.oldDarens = []

    },
    handleAdd(item) {
      this.addExpertPopVisible = true
      if(item) {
        this.oldDarens = item.darens;
        this.addDarenItem = item
      }else {
        this.addDarenItem = null
      }
    },
    async handleDelete(item,index) {
      console.log(item,index, 'item')
      this.loading = true
      const res = await MiniModel.dyLifePlanClose({
        planId:item.planId,
        type: this.activeName,
      })
      this.loading = false
      if(res.data.code !== 200) {
        this.$message.error(res.data.message)
        return
      }
      // TODO删除对应tab下的item
      this.form.items.splice(index,1)
    },
    handleBlur(e,index) {
      console.log(e, index, 'e,index111')
    },
    handleInput(e,index,typeStr) {
      console.log(e, index, typeStr,'e,index')
      if(this.type ===1 || this.type === 3) {
        if(typeStr === 'commissionRate') {
          if(this.activeName === '3') {
            if(!matchNegativePart3.test(e) || (Number(e) < 1 || Number(e) > 29)) {
              this.form1.items[index].error = '请输入1~29，最多1位小数';
            } else {
              this.form1.items[index].error = '';
            }
          }else{
            if(!matchNegativePart3.test(e) || (Number(e) < 0.01 || Number(e) > 29)) {
              this.form1.items[index].error = '请输入0.01~29';
            } else {
              this.form1.items[index].error = '';
            }
          }
        }else if(typeStr === 'planName') {
          if(!e) {
            this.form1.items[index].errorNamne = '名称不能为空';
            return
          } else {
            this.form1.items[index].errorNamne = '';
          }
          if(e.length > 20) {
            this.form1.items[index].errorNamne = '名称不能超过20个字符';
          } else {
            this.form1.items[index].errorNamne = '';
          }
        }else if(typeStr === 'commissionDuration') {
          this.$forceUpdate()
          if(!matchIntegerNew.test(e)) {
            this.timeDayErr = '请输入正整数'
          } else {
            this.timeDayErr = '';
          }
        }
      }else if(this.type ===2) {
        if(this.activeName === '3'){
          if(!matchNegativePart3.test(e) || (Number(e) < 1 || Number(e) > 29)) {
            this.form.items[index].error = '请输入1~29，最多1位小数';
          } else {
            this.form.items[index].error = '';
          }
        }else{
          if(!matchNegativePart3.test(e) || (Number(e) < 0.01 || Number(e) > 29)) {
            this.form.items[index].error = '请输入0.01~29';
          } else {
            this.form.items[index].error = '';
          }
        }
      }
    },
    clearValidate() {
      this.timeErr = ''
      this.form1.items.forEach(item => {
        item.error = '';
        item.errorNamne = '';
        item.errorDarens = '';
      });
      this.form.items.forEach(item => {
        item.error = '';
      });
    },
    async validate1() {
      let errorMessage = ''
      if(this.form1.items.length === 0) {
        errorMessage = '请添加计划'
      }else{
        this.form1.items.forEach(item => {
          if(!item.planName || item.planName.length > 20) {
            item.errorNamne = '名称不能为空且不能超过20个字符';
            errorMessage = '名称不能为空且不能超过20个字符'
          }
          if(this.activeName === '3') {
            if(!matchNegativePart3.test(item.commissionRate) || (Number(item.commissionRate) < 1 || Number(item.commissionRate) > 29)) {
              item.error = '请输入1~29，最多1位小数';
              errorMessage = '请输入1~29，最多1位小数'
            }
          }
          if(this.activeName !== '3' && !item.darens.length) {
            item.errorDarens = '请添加达人';
            errorMessage = '请添加达人'
          } else {
            item.errorDarens = '';
          }
        });
      }
      if( this.activeName === '1') {
        if(!this.form1.grantTimeArr.length) {
          this.timeErr = '请选择开始时间和结束时间'
          errorMessage = '请选择开始时间和结束时间'
        }
        if(this.form1.commissionDuration === "" || !matchIntegerNew.test(this.form1.commissionDuration) ) {
          this.timeDayErr = '请输入正整数'
          errorMessage = '请输入正整数'
        }
      }

      console.log(errorMessage,'validate1')
      if(errorMessage) {
        this.$message.error(errorMessage)
        return Promise.reject(errorMessage);
      }
      return Promise.resolve();
    },
    async validate() {
      this.timeErr = ''
      let errorMessage = ''
      if(this.form.items.length === 0) {
        console.log('=========111')
        errorMessage = '请添加计划'
      }else{
        console.log('=========222')
        this.form.items.forEach(item => {
          if(!matchNegativePart3.test(item.commissionRate) || (Number(item.commissionRate) < 1 || Number(item.commissionRate) > 29)) {
            item.error = '请输入1~29的整数';
            errorMessage = '请输入1~29的整数'
            return;
          }
        });
        console.log(this.form.grantTimeArr.length,'this.form.grantTimeArr.length',this.activeName)
        if(!this.form.grantTimeArr.length && this.activeName === '1') {
          this.timeErr = '请选择开始时间和结束时间'
          errorMessage = '请选择开始时间和结束时间'
        }
      }
      if(errorMessage) {
        this.$message.error(errorMessage)
        return Promise.reject(errorMessage);
      }
      return Promise.resolve();
    },
    async submit() {
      if(this.type === 1 || this.type === 3) {
        await this.validate1()
        let types = this.activeName
        let products = JSON.parse(JSON.stringify(this.form1.items))
        console.log(products,'productsproducts')
        if(types == 3) {
          delete products.darens
        }else{
          products[0].darens = products[0].darens.filter(item => {
            return !item.disabled
          })
        }
        if(types == 1) {
          products.forEach(item => {
            console.log(item,'item')
            item.darens.forEach((itemDaren => {
              itemDaren.startTime = this.form1.grantTimeArr[0]
              itemDaren.endTime = this.form1.grantTimeArr[1]
              itemDaren.commissionDuration = this.form1.commissionDuration
            }))
          })
        }
        let params = {
          appKey:localStorage.getItem("appKeyMini"),
          types:[{
            // startTime: types == 1 ? this.form1.grantTimeArr[0] : '',
            // endTime: types == 1 ?this.form1.grantTimeArr[1] : '',
            type: types,
            products:products,
            // commissionDuration: types == 1 ? this.form1.commissionDuration : '',
          }]
        }
        console.log(params,'paramsparams')
        // return
        this.submitLoading = true
        const res = await MiniModel.dyLifePlanCreate(params)
        console.log(res,'新增')
        this.submitLoading = false
        if(res.data.code !== 200) {
          this.$message.error(res.data.message)
          return
        }
        this.$message.success('创建成功')
        let datas = JSON.parse(JSON.stringify(products))
        this.$set(this.form1Default,Number(types)-1,datas)
        this.$emit('refresh')
        this.closeReset()
      }else if(this.type === 2) {
        await this.validate()
        let types = this.activeName
        let products = JSON.parse(JSON.stringify(this.form.items))
        if(types == 3) {
          delete products.darens
        }
        let params = {
          appKey:localStorage.getItem("appKeyMini"),
          types:[{
            startTime: types == 1 ? this.form.grantTimeArr[0] : '',
            endTime: types == 1 ?this.form.grantTimeArr[1] : '',
            type: types,
            products:products,
          }]
        }
        console.log(params,'paramsparams==编辑')
        return
        this.submitLoading = true
        const res = MiniModel.dyLifePlanEdit({})
        this.submitLoading = false
      }
      // this.submitLoading = true
      console.log('通过')
      // this.$refs.form.validate((valid) => {
      //   if (valid) {
      //     console.log("submit success!!");
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    onCancel() {
      this.dialogVisible = false;
    },
    handleChange(e) {
      console.log(e,'handleChange',typeof e.name,this.type)
      this.clearValidate()
      if(this.type === 1 || this.type === 3) {
        this.form1.items = JSON.parse(JSON.stringify(this.form1Default[Number(e.name) - 1]))
      }else if(this.type === 2) {
        this.form.items = this.formDefault[Number(e.name)] ? JSON.parse(JSON.stringify(this.formDefault[Number(e.name)].planDetails)) : [];
        if(e.name === '1'){
          this.form.grantTimeArr = this.formDefault[Number(e.name)].startTime ? [this.formDefault[Number(e.name)].startTime, this.formDefault[Number(e.name)].endTime] : "";
        }
        console.log(this.formDefault[Number(e.name)],'aaaaa')
      }
    },
    closeReset() {
      this.dialogVisible = false;
    },
    handleClose() {
      console.log("右上角取消==1");
      this.closeReset();
    },
    reset() {
      this.form = {
        grantTimeArr:"",
        items :[]
      }
      this.form1 = {
        grantTimeArr:"",
        items :[]
      }
      this.timeErr = ''
      this.addDarenItem = null
      this.form1Default = []
      this.formDefault = []
      this.activeName = '3'
      this.submitLoading = false
      this.clearValidate()
    },
    async open(type,row,planDetails,listRow) {
      console.log(type, row, planDetails,'open===type,row',row[3],row[1],row[2],planDetails.length)
      console.log(listRow,'listRowlistRow')
      this.reset()
      this.type = type
      this.dialogVisible = true
      if(type === 3) {
        this.rowAdd = planDetails
        this.title = '添加计划推广'
        if(!(row[1] && row[2] && row[3])) {
          console.log('空的===')
        }
        let productsList = null
        productsList = {
          thirdProductId:listRow.thirdProductId,
          productName:listRow.productName,
          versionCode:listRow.versionCode,

          planName: '',
          planId: '',
          commissionRate: '',
          darens:[],//达人列表
          errorNamne: '',
          error:'',
          timeErr:'',
          errorDarens:'',
        }

        console.log(productsList,'productsList===计划推广')
        // 1短视频，2直播，3通用
        let arr = ['3','1','2']
        const keys = Object.keys(row);
        console.log(keys,'keys===',row)
        // 找出 arr 中存在但 arr2 中不存在的值
        const diff = arr.filter(item => !keys.includes(item));

        let data = JSON.parse(JSON.stringify(productsList))
        console.log(data,'diff===',diff)
        let list = [[data],[data],[data]];
        console.log(list,'list===1111')
        this.disabled = false
        if(row[1]) {
          console.log('有短视频',row[1])
          if(row[1].startTime) {
            this.disabled = true
          }
          // this.form1.grantTimeArr = row[1].startTime ? [row[1].startTime, row[1].endTime] : ""
          // this.form1.commissionDuration = row[1].commissionDuration;
          this.form1.grantTimeArr = ""
          this.form1.commissionDuration = "";
          let daren = row[1].planDetails.map(item => {
            return {
              douyinId: item.douyinId,
              commissionRate: item.commissionRate,
              disabled:true,
            }
          })
          if(row[1].planDetails.length) {
            list[0] = [
              {
                ...productsList,
                // darens:daren,
                // planName: row[1].planDetails[0].planName ? row[1].planDetails[0].planName : '',
                planName:'',
                darens:[],
              }
            ]
          }
        }
        if(row[2]) {
          console.log('有直播',row[2].planDetails)
          let daren = row[2].planDetails.map(item => {
            return {
              douyinId: item.douyinId,
              commissionRate: item.commissionRate,
              disabled:true,
            }
          })
          if(row[2].planDetails.length) {
            list[1] = [
              {
                ...productsList,
                darens:daren,
                planName: row[2].planDetails[0].planName ? row[2].planDetails[0].planName : '',
                // ...row[2].planDetails[0]
              }
            ]
          }

        }
        if(row[3]) {
          console.log('有通用',row[3])
          if(row[3].planDetails.length) {
            list[2] = [
              {
                ...productsList,
                ...row[3].planDetails[0],
                planName: row[3].planDetails[0].planName ? row[3].planDetails[0].planName : '',
              }
            ]
          }
        }
        this.form1Default = list
        this.form1.items = JSON.parse(JSON.stringify(this.form1Default[2]));
        console.log(this.form1Default,'list===计划推广22')
        return
      }
      // 添加计划
      if(type === 1) {
        this.rowAdd = row
        this.title = '添加计划推广'
        let {startTime, endTime} = this.getTime();
        this.form1.grantTimeArr = [startTime, endTime];
        this.form1.items = row.map(item => {
          return {
            // ...item,
            thirdProductId:item.thirdProductId,
            productName:item.productName,
            versionCode:item.versionCode,
            commissionRate: '',
            planName:'', //计划名称
            darens:[],//达人列表
            errorNamne: '',
            error:'',
            timeErr:'',
            errorDarens:'',
          }
        })
        let data = JSON.parse(JSON.stringify(this.form1.items))
        // [短视频，直播，通用]
        this.form1Default = [data,data,data]
        console.log(this.form1Default,'this.form1Default')
      }else if(type === 2) {
        this.rowList = row
        this.loading = true
        // 管理计划
        this.title = '计划管理'
        const res = await MiniModel.dyLifePlanGoodsPlan({
          thirdProductId: String(row.thirdProductId),
        })
        this.loading = false
        if(res.data.code !== 200) {
          this.$message.error(res.data.message);
          return;
        }
        for(let key in res.data.data) {
          res.data.data[key].planDetails.forEach(item => {
            item.error = '';
          })
        }
        this.formDefault = res.data.data;
        console.log(res.data.data,'管理计划res',this.formDefault,this.formDefault[2])
      }
    },
  },
}
</script>

<style scoped lang="less">
/deep/.el-dialog.import-dialog {
  max-height: calc(100vh - 100px) !important;
  // max-height: 800px;
  overflow-y: auto;
  background: #f5f5f5;
  z-index: 999 !important;
  // margin: auto !important;
}
.box{
  background: #fff;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 8px;
}
.title{
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}
.row{
  display: flex;
}
.header-text{
  margin-right: 30px;
}
.btns-coantainer{
  //position: absolute;
  //bottom: 30px;
  //right: 40px;
  z-index: 99;
  //width: 100%;
  padding: 10px;
  display: flow;
  float: right;
}
.list-container{
  height: calc(100vh - 440px);
  overflow-y: auto;
}
.list-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list{
  margin-top: 10px;
  padding: 16px 10px;
  .item{
    display: flex;
    justify-content: space-between;
  }
}
.add{
  color: #409EFF;
  cursor: pointer;
  text-align: right;
}
.item-box{
  //width: 200px;
  display: flex;
  padding-top: 10px;
  //flex: 1;
  //align-items: center;
}
.item-box-left{
  width: 70px;
}
.item-box-right{
  width: 150px;
  color: #333;
}
.picker-container{
  position: absolute;
  left: 0px;
  bottom: 10px;
  background: #fff;
  width: 98%;
  display: flex;
}
.header-num{
  color: #52c41a;
  display: flex;
  margin-right: 30px;
  .yuan{
    background: #52c41a;
  }
}
.header-set{
  color: #1677ff;
  display: flex;
  .yuan{
    background: #1677ff;
  }
}
.yuan{
  width: 20px;
  height: 20px;
  border-radius: 10px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/manageDetailPopNew.vue